import React, { useEffect } from 'react';
import PersonalboqenPublic from './pages/PersonalboqenPublic';
import DirectContractSign from './pages/DirectContractSign';
import ContractTemplates from './pages/admin/ContractTemplates';
import ContractSignings from './pages/admin/ContractSignings';
import PersonalDashboard from './pages/admin/PersonalDashboard';
import BVManagementPage from './pages/admin/BVManagementPage';
import EmployeeDetail from './pages/admin/EmployeeDetail';

import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import { ModulesProvider } from './contexts/ModulesContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { OnboardingProvider } from './contexts/OnboardingContext';
import { InfoModulesProvider } from './contexts/InfoModulesContext';
import InfoModuleManagement from './pages/admin/InfoModuleManagement';
import InfoTablePage from './pages/admin/InfoTablePage';
import InfoPdfPage from './pages/admin/InfoPdfPage';
import InfoMeterPage from './pages/admin/InfoMeterPage';
import InfoAbscheiderPage from './pages/admin/InfoAbscheiderPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { setupSubscriptionGuardInterceptor } from './utils/subscriptionGuardInterceptor';
import { DashboardLayout } from './components/DashboardLayout';
import { GlobalMobileBackButton } from './components/GlobalMobileBackButton';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { FirstLoginPasswordChange } from './pages/FirstLoginPasswordChange';
import SetPasswordFromInvitation from './pages/auth/SetPasswordFromInvitation';
import { EmailVerificationPending } from './pages/EmailVerificationPending';
import { VerifyEmail } from './pages/VerifyEmail';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { AGB } from './pages/AGB';
import { ReferralDashboard } from './pages/admin/ReferralDashboard';
import { ModuleManagement } from './pages/admin/ModuleManagement';
import { AdminLocations } from './pages/admin/AdminLocations';
import { LocationModules } from './pages/admin/LocationModules';
import { LocationNew } from './pages/admin/LocationNew';
import { LocationPayment } from './pages/admin/LocationPayment';
import { BulkLocationCreate } from './pages/admin/BulkLocationCreate';
import { BulkLocationPayment } from './pages/admin/BulkLocationPayment';
import { CustomerModuleManagement } from './pages/superadmin/CustomerModuleManagement';
import { TestBilling } from './pages/admin/TestBilling';
import Lieferungen from './pages/admin/Lieferungen';
import LieferungDetail from './pages/admin/LieferungDetail';
import Reklamation from './pages/admin/Reklamation';
import LieferKalender from './pages/LieferKalender';
import TresorPage from './pages/admin/TresorPage';
import { WegfahrerDashboard } from './pages/admin/WegfahrerDashboard';
import { WegfahrerDetail } from './pages/admin/WegfahrerDetail';
import { WegfahrerSettings } from './pages/admin/WegfahrerSettings';
import { WegfahrerForm } from './pages/employee/WegfahrerForm';
import MitarbeiterMinusAdmin from './pages/admin/MitarbeiterMinusAdmin';
import MeineAbrechnung from './pages/MeineAbrechnung';
import { SuperadminDashboard } from './pages/superadmin/SuperadminDashboard';
import { SuperadminStatistics } from './pages/superadmin/SuperadminStatistics';
import { SuperadminSettings } from './pages/superadmin/SuperadminSettings';
import { CustomerManagement } from './pages/superadmin/CustomerManagement';
import { CustomerList } from './pages/superadmin/CustomerList';
import LicenseDiagnosis from './pages/superadmin/LicenseDiagnosis';
import BillingV2CheckoutTest from './pages/superadmin/BillingV2CheckoutTest';
import StripeControlCenter from './pages/superadmin/stripe/StripeControlCenter';
import { UserList } from './pages/superadmin/UserList';
import SuperadminSupportTickets from './pages/superadmin/SuperadminSupportTickets';
import { LocationList } from './pages/superadmin/LocationList';import QuickCreateUser from './pages/superadmin/QuickCreateUser';
import { DeletionRequests } from './pages/superadmin/DeletionRequests';
import { Notifications } from './pages/superadmin/Notifications';
import { FeatureFlags } from './pages/superadmin/FeatureFlags';
import ModuleManagementSA from './pages/superadmin/ModuleManagement';
import { ProductManagement } from './pages/superadmin/ProductManagement';
import { EANCleanup } from './pages/superadmin/EANCleanup';
import { ProductImport } from './pages/superadmin/ProductImport';
import { ProductImportProgress } from './pages/superadmin/ProductImportProgress';
import { PendingProductsReview } from './pages/superadmin/PendingProductsReview';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import AddonSuccess from './pages/admin/AddonSuccess';
import { LocationManagement } from './pages/admin/LocationManagement';
import { LocationManagementEnhanced } from './pages/admin/LocationManagementEnhanced';
import { EmployeeManagement } from './pages/admin/EmployeeManagement';
import { EmployeeManagementEnhanced } from './pages/admin/EmployeeManagementEnhanced';
import { TemperatureSettings } from './pages/admin/TemperatureSettings';
import { TemperatureExport } from './pages/admin/TemperatureExport';
import { TemperatureAlerts } from './pages/admin/TemperatureAlerts';
import { CompanySettings } from './pages/admin/CompanySettings';
import { Settings } from './pages/admin/Settings';
import AdminProfil from './pages/admin/AdminProfil';
import { AdminSubscription } from './pages/admin/AdminSubscription';
import ProductCatalog from './pages/admin/ProductCatalog';
import { DeleteAccount } from './pages/admin/DeleteAccount';
import { NotificationsPage } from './pages/admin/NotificationsPage';
import { AdminInvoices } from './pages/admin/AdminInvoices';
import { DunningTestTool } from './pages/admin/DunningTestTool';
import { SuperadminCustomerSubscription } from './pages/superadmin/SuperadminCustomerSubscription';
import { TemperatureControl } from './pages/shared/TemperatureControl';
import { AdminTemperatureInput } from './pages/admin/AdminTemperatureInput';
import { EmployeeDashboard } from './pages/employee/EmployeeDashboard';
import { TemperatureRecording } from './pages/employee/TemperatureRecording';
import { ImprovementSuggestions } from './pages/employee/ImprovementSuggestions';
import { ImprovementSuggestionsAdmin } from './pages/admin/ImprovementSuggestionsAdmin';
import { TaskTypes } from './pages/admin/TaskTypes';
import SchichtConfig from './pages/admin/SchichtConfig';
import SchichtProtokoll from './pages/admin/SchichtProtokoll';
import Schichtabrechnung from './pages/admin/Schichtabrechnung';
import { TaskReport } from './pages/admin/TaskReport';
import GutscheinZentrale from './pages/superadmin/GutscheinZentrale';
import DataIntegrityCheck from './pages/superadmin/DataIntegrityCheck';
import { SchichtView } from './pages/employee/SchichtView';
import TagesaufgabenView from './pages/employee/TagesaufgabenView';
import TagesgeschaeftPage from './pages/employee/TagesgeschaeftPage';
import TagesgeschaeftEmpfangen from './pages/employee/TagesgeschaeftEmpfangen';
import AuffuellenPage from './pages/employee/AuffuellenPage';
import ReinigungsplanPage from './pages/employee/ReinigungsplanPage';
import EinkaufslistePage from './pages/employee/EinkaufslistePage';
import PressInventoryList from './pages/inventory/PressInventoryList';
import PressInventoryDetail from './pages/inventory/PressInventoryDetail';
import ManualInventoryList from './pages/inventory/ManualInventoryList';
import ManualInventoryDetail from './pages/inventory/ManualInventoryDetail';
import { StatisticsExport } from './pages/admin/StatisticsExport';
import { ExportsOverview } from './pages/admin/ExportsOverview';
import { Statistik } from './pages/admin/Statistik';
import { AllgemeinExport } from './pages/admin/AllgemeinExport';
import { AllgemeinExportView } from './pages/admin/AllgemeinExportView';
import { AllgemeinTypen } from './pages/admin/AllgemeinTypen';
import { BestellKategorien } from './pages/admin/BestellKategorien';
import { BestellProdukte } from './pages/admin/BestellProdukte';
import { BestellungenExport } from './pages/admin/BestellungenExport';
import { BestellKategorie } from './pages/shared/BestellKategorie';
import { BestellHistorie } from './pages/shared/BestellHistorie';
import { MHDControl } from './pages/shared/MHDControl';
import { MHDExport } from './pages/admin/MHDExport';
import { MHDExportView } from './pages/admin/MHDExportView';
import { Abschriften } from './pages/shared/Abschriften';
import { BackshopAbschriften } from './pages/shared/BackshopAbschriften';
import BackshopBelegung from './pages/admin/BackshopBelegung';
import { AllgemeineAbschriften } from './pages/shared/AllgemeineAbschriften';
import { AbschriftenExport } from './pages/admin/AbschriftenExport';
import { BackshopExport } from './pages/admin/BackshopExport';
import { BackshopExportView } from './pages/admin/BackshopExportView';
import { BackshopListe } from './pages/admin/BackshopListe';
import { BackshopAlleProdukte } from './pages/admin/BackshopAlleProdukte';
import { UnterweisungenKategorien } from './pages/admin/UnterweisungenKategorien';
import { KategorieDetail } from './pages/admin/KategorieDetail';
import { UnterweisungenMitarbeiter } from './pages/admin/UnterweisungenMitarbeiter';
import { UnterweisungenErstellen } from './pages/admin/UnterweisungenErstellen';
import { Lotto } from './pages/admin/Lotto';
import { LottoOverview } from './pages/admin/LottoOverview';
import { LottoProduktVerwaltung } from './pages/admin/LottoProduktVerwaltung';
import { LottoRubellose } from './pages/admin/LottoRubellose';
import { UnterweisungenNew } from './pages/employee/UnterweisungenNew';
import MeineBetriebsvereinbarungenPage from './pages/MeineBetriebsvereinbarungenPage';
import { LottoEmployee } from './pages/employee/LottoEmployee';
import { LottoEmployeeRubellose } from './pages/employee/LottoEmployeeRubellose';
import MeineDokumentePage from './pages/employee/MeineDokumentePage';
import { NotificationHistory } from './pages/shared/NotificationHistory';
import { UnterweisungenExport } from './pages/admin/UnterweisungenExport';
import AffiliateRegister from './pages/affiliate/AffiliateRegister';
import AffiliateRegisterNew from './pages/affiliate/AffiliateRegisterNew';
import AffiliateRegisterSuccess from './pages/affiliate/AffiliateRegisterSuccess';
import AffiliateDashboard from './pages/affiliate/AffiliateDashboard';
import AffiliateLogin from './pages/affiliate/AffiliateLogin';
import AffiliateDashboardNew from './pages/affiliate/AffiliateDashboardNew';
import AffiliateProfile from './pages/affiliate/AffiliateProfile';
import AffiliateSetPassword from './pages/affiliate/AffiliateSetPassword';
import Reactivate from './pages/auth/Reactivate';
import DemoLanding from './pages/DemoLanding';
import DemoBanner from './components/DemoBanner';
import AffiliateManagement from './pages/superadmin/AffiliateManagement';
import SuperadminAffiliateDashboard from './pages/superadmin/SuperadminAffiliateDashboard';
import AffiliateDetailsPage from './pages/superadmin/AffiliateDetailsPage';
import SuperadminAnalytics from './pages/superadmin/SuperadminAnalytics';
import { SuperadminHelpCenter } from './pages/superadmin/SuperadminHelpCenter';
import SuperadminBackshopMerge from './pages/superadmin/SuperadminBackshopMerge';
import { TankstellenHub } from './pages/superadmin/TankstellenHub';
import { DemoSessions } from './pages/superadmin/DemoSessions';
import { ReferralReview } from './pages/superadmin/ReferralReview';
import { BackshopVorschlaege } from './pages/admin/BackshopVorschlaege';
import TGTGOrders from './pages/TGTGOrders';
import { HelpCenter } from './pages/HelpCenter';
import PlanogrammPage from './pages/admin/PlanogrammPage';
import { ZusatzAdmin } from './pages/admin/ZusatzAdmin';
import { ZusatzEmployee } from './pages/employee/ZusatzEmployee';
import './App.css';

// Interceptor Setup Component
function InterceptorSetup() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Setup axios interceptor for 402 errors
    setupSubscriptionGuardInterceptor(navigate);
  }, [navigate]);
  
  return null;
}

// Wrapper für SchichtView der die schichtId aus der URL extrahiert
function SchichtViewWrapper() {
  const { schichtId } = useParams();
  return <SchichtView schichtId={schichtId} />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ModulesProvider>
          <InfoModulesProvider>
          <BrowserRouter>
            <OnboardingProvider>
              <InterceptorSetup />
              <GlobalMobileBackButton />
              <DemoBanner />
              <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/set-password" element={<SetPasswordFromInvitation />} />
            <Route path="/register" element={<Register />} />
            {/* 🆕 BUG 1 FIX: Alias route for referral links */}
            <Route path="/register-enhanced" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/first-login-password-change" element={<FirstLoginPasswordChange />} />
            
            {/* 🆕 DOI: Email Verification Routes */}
            <Route path="/verification-pending" element={<EmailVerificationPending />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            
            {/* Legal Pages - Public */}
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            
            {/* Affiliate Public Routes */}
            <Route path="/affiliate/register" element={<AffiliateRegisterNew />} />
            <Route path="/affiliate/register/success" element={<AffiliateRegisterSuccess />} />
            <Route path="/affiliate/login" element={<AffiliateLogin />} />
            <Route path="/affiliate/set-password" element={<AffiliateSetPassword />} />
            <Route path="/reactivate" element={<Reactivate />} />
            <Route path="/demo" element={<DemoLanding />} />
            <Route path="/demo/:brand" element={<DemoLanding />} />
            <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
            <Route path="/affiliate/dashboard-new" element={<AffiliateDashboardNew />} />
            <Route path="/affiliate/profile" element={<AffiliateProfile />} />

          {/* Superadmin Routes */}
          <Route
            path="/superadmin"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/statistics"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminStatistics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/quick-create-user"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <QuickCreateUser />
              </ProtectedRoute>
            }
          />

          <Route
            path="/superadmin/customers"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <CustomerList />
              </ProtectedRoute>
            }
          />
          {/* Stripe Control Center – Phase 1a */}
          <Route
            path="/superadmin/stripe/*"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <StripeControlCenter />
              </ProtectedRoute>
            }
          />
          {/* Phase 2B.1: Lizenz-Diagnose */}
          <Route
            path="/superadmin/license"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <LicenseDiagnosis />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/billing-v2-checkout-test"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <BillingV2CheckoutTest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/gutscheine"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <GutscheinZentrale />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/referral-review"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <ReferralReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/users"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/feature-flags/:customerId"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <FeatureFlags />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/module-management"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <CustomerModuleManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/superadmin/customer/:customerId/subscription"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminCustomerSubscription />
              </ProtectedRoute>
            }
          />

          <Route
            path="/superadmin/products"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <ProductManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/products/import"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <ProductImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/products/import-progress/:importId"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <ProductImportProgress />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/products/report/:importId"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <ProductImportProgress />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/ean-cleanup"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <EANCleanup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/backshop-merge"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminBackshopMerge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/pending-products"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <PendingProductsReview />
              </ProtectedRoute>
            }
          />


          <Route
            path="/superadmin/notifications"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/support"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminSupportTickets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/settings"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/affiliates"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminAffiliateDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/analytics"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/industry/tankstelle"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <TankstellenHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/affiliates/:affiliateId"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <AffiliateDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/affiliates/management"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <AffiliateManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/help-center"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <SuperadminHelpCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/data-integrity"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <DataIntegrityCheck />
              </ProtectedRoute>
            }
          />
          <Route
            path="/superadmin/demo-sessions"
            element={
              <ProtectedRoute allowedRoles={['superadmin']}>
                <DemoSessions />
              </ProtectedRoute>
            }
          />

          {/* Help Center – alle eingeloggten Nutzer */}
          <Route
            path="/help"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung', 'superadmin']}>
                <HelpCenter />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          {/* OLD ROUTE REMOVED - Now using AdminLocations for package-based module management */}
          <Route
            path="/admin/employees"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <EmployeeManagementEnhanced />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/lieferungen"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <Lieferungen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lieferung"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'admin', 'stationsleitung', 'employee']}>
                <Lieferungen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lieferung/reklamation"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <Reklamation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lieferung/kalender"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'admin', 'stationsleitung', 'employee']}>
                <LieferKalender />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tresor"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee']}>
                <TresorPage />
              </ProtectedRoute>
            }
          />
          {/* ── WEGFAHRER REPORTING ─────────────────────────────── */}
          <Route path="/admin/wegfahrer" element={<ProtectedRoute allowedRoles={['admin','stationsleitung','superadmin']}><WegfahrerDashboard /></ProtectedRoute>} />
          <Route path="/admin/reporting/mitarbeiter-minus" element={<ProtectedRoute allowedRoles={['admin','stationsleitung','superadmin']}><MitarbeiterMinusAdmin /></ProtectedRoute>} />
          <Route path="/meine-abrechnung" element={<ProtectedRoute allowedRoles={['employee','stationsleitung','admin']}><MeineAbrechnung /></ProtectedRoute>} />
          <Route path="/employee/dokumente" element={<ProtectedRoute allowedRoles={['employee','stationsleitung','admin']}><MeineDokumentePage /></ProtectedRoute>} />
          <Route path="/admin/wegfahrer/settings" element={<ProtectedRoute allowedRoles={['admin','stationsleitung','superadmin']}><WegfahrerSettings /></ProtectedRoute>} />
          <Route path="/admin/wegfahrer/:id" element={<ProtectedRoute allowedRoles={['admin','stationsleitung','superadmin']}><WegfahrerDetail /></ProtectedRoute>} />
          <Route path="/wegfahrer/neu" element={<ProtectedRoute><WegfahrerForm /></ProtectedRoute>} />

          <Route
            path="/lieferung/:id"
            element={
              <ProtectedRoute allowedRoles={['superadmin', 'admin', 'stationsleitung', 'employee']}>
                <LieferungDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/subscription"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminSubscription />
              </ProtectedRoute>
            }
          />
          {/* ── Zentrale Profil-Seite (neu) ──────────────────────────────────────── */}
          <Route
            path="/admin/profil"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <AdminProfil />
              </ProtectedRoute>
            }
          />
          {/* /admin/company und /admin/settings bleiben als echte Seiten erhalten.
              Direktlinks/Deep-Links (E-Mails, Bookmarks) funktionieren weiterhin.
              Die Profil-Seite verlinkt auf /admin/company → öffnet CompanySettings direkt. */}
          <Route
            path="/admin/company"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <CompanySettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/referrals"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ReferralDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/invoices"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminInvoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/delete-account"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <DeleteAccount />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/subscription/success"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminSubscription />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/notifications"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee']}>
                <NotificationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dunning-test"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <DunningTestTool />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/temperature"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <TemperatureSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/temperature-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <TemperatureExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/temperature-alerts"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <TemperatureAlerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/temperature-control"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <TemperatureControl />
              </ProtectedRoute>
            }
          />
          {/* Redirect old Module & Add-ons route to Standorte (module management is now per-location) */}
          <Route
            path="/admin/modules"
            element={<Navigate to="/admin/locations" replace />}
          />
          <Route
            path="/admin/locations"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminLocations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/locations/new"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <LocationNew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/locations/bulk-new"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BulkLocationCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/locations/:locationId/payment"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <LocationPayment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/locations/bulk-payment"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BulkLocationPayment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/locations/:locationId/modules"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <LocationModules />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/addon/success"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <AddonSuccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/test-billing"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <TestBilling />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/temperature-input"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminTemperatureInput />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/task-report"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'superadmin']}>
                <TaskReport />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/task-types" element={<Navigate to="/aufgaben" replace />} />
          <Route
            path="/admin/schicht-config"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <SchichtConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/schicht-protokoll"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <SchichtProtokoll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/schichtabrechnung"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'superadmin']}>
                <Schichtabrechnung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schicht/:schichtId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <SchichtViewWrapper />
              </ProtectedRoute>
            }
          />
          <Route path="/aufgaben" element={<ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}><TagesgeschaeftPage /></ProtectedRoute>} />
          <Route path="/tagesgeschaeft/empfangen" element={<ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'superadmin']}><TagesgeschaeftEmpfangen /></ProtectedRoute>} />
          <Route path="/aufgaben/auffuellen" element={<ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}><AuffuellenPage /></ProtectedRoute>} />
          <Route path="/aufgaben/reinigung" element={<ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}><ReinigungsplanPage /></ProtectedRoute>} />
          <Route path="/einkaufsliste" element={<ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}><EinkaufslistePage /></ProtectedRoute>} />
          <Route path="/inventur/presse" element={<ProtectedRoute allowedRoles={['admin', 'stationsleitung']}><PressInventoryList /></ProtectedRoute>} />
          <Route path="/inventur/presse/:id" element={<ProtectedRoute allowedRoles={['admin', 'stationsleitung']}><PressInventoryDetail /></ProtectedRoute>} />
          <Route path="/inventur/manuell" element={<ProtectedRoute allowedRoles={['admin', 'stationsleitung']}><ManualInventoryList /></ProtectedRoute>} />
          <Route path="/inventur/manuell/:id" element={<ProtectedRoute allowedRoles={['admin', 'stationsleitung']}><ManualInventoryDetail /></ProtectedRoute>} />
          <Route
            path="/admin/improvement-suggestions"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ImprovementSuggestionsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/statistics-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <StatisticsExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/mhd-control"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MHDControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/produkte"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'superadmin']}>
                <ProductCatalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/mhd-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <MHDExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/mhd-export/:exportId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <MHDExportView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/exports-overview"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <ExportsOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/statistik"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <Statistik />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/allgemein-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <AllgemeinExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Abschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/backshop-liste"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopListe />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/alle-produkte"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopAlleProdukte />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/backshop"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopAbschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/backshop-belegung"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee']}>
                <BackshopBelegung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/backshop/vorschlaege"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopVorschlaege />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/tgtg"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee']}>
                <TGTGOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/allgemein"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AllgemeineAbschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <AbschriftenExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/backshop-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/abschriften/backshop-export/:exportId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BackshopExportView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/allgemein-typen"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AllgemeinTypen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/allgemein-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <AllgemeinExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/general-exports/:exportId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <AllgemeinExportView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bestell-kategorien"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BestellKategorien />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bestell-produkte"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BestellProdukte />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bestellungen-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <BestellungenExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unterweisungen"
            element={<Navigate to="/admin/unterweisungen/kategorien" replace />}
          />
          <Route
            path="/admin/unterweisungen/kategorien"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <UnterweisungenKategorien />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unterweisungen/kategorien/:categoryName"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <KategorieDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unterweisungen/mitarbeiter"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <UnterweisungenMitarbeiter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unterweisungen/erstellen"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <UnterweisungenErstellen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unterweisungen/export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <UnterweisungenExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/lotto"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <LottoOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/lotto/produktverwaltung"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <LottoProduktVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/lotto/rubellose"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <LottoRubellose />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bestellungen/:categoryId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <BestellKategorie />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bestellungen/historie"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <BestellHistorie />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung', 'superadmin']}>
                <NotificationHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/planogramme"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee', 'superadmin']}>
                <PlanogrammPage />
              </ProtectedRoute>
            }
          />
          {/* Universelle Info-Listen */}
          <Route
            path="/admin/info/manage"
            element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <InfoModuleManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/info/pdf/:moduleId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee', 'superadmin']}>
                <InfoPdfPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/info/table/:moduleId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee', 'superadmin']}>
                <InfoTablePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/info/meter/:moduleId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee', 'superadmin']}>
                <InfoMeterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/info/abscheider/:moduleId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung', 'employee', 'superadmin']}>
                <InfoAbscheiderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/zusatz"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stationsleitung']}>
                <ZusatzAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/zusatz"
            element={
              <ProtectedRoute allowedRoles={['employee', 'admin', 'stationsleitung']}>
                <ZusatzEmployee />
              </ProtectedRoute>
            }
          />
          {/* Employee Routes */}
          <Route
            path="/employee/dashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee"
            element={<Navigate to="/employee/dashboard" replace />}
          />

          <Route
            path="/employee/temperature"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <TemperatureRecording />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/temperature-control"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <TemperatureControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/improvement-suggestions"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <ImprovementSuggestions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/mhd-control"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <MHDControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/abschriften"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <Abschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/abschriften/backshop"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <BackshopAbschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/abschriften/allgemein"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <AllgemeineAbschriften />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/unterweisungen"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <UnterweisungenNew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/lotto"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <LottoEmployeeRubellose />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil/betriebsvereinbarungen"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <MeineBetriebsvereinbarungenPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/*"
            element={
              <ProtectedRoute allowedRoles={['admin', 'employee', 'stationsleitung']}>
                <div className="min-h-screen flex items-center justify-center">
                  <div className="text-center space-y-4">
                    <h2 className="text-2xl font-bold">Modul in Entwicklung</h2>
                    <p className="text-muted-foreground">Diese Funktion wird bald verfügbar sein.</p>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />

          {/* Öffentliche Seite für Personalbogen (kein Login) */}
          <Route path="/personalbogen/:token" element={<PersonalboqenPublic />} />
          <Route path="/vertrag/:token" element={<DirectContractSign />} />

          <Route path="/admin/vertragsvorlagen" element={<ProtectedRoute allowedRoles={['admin','superadmin']}><ContractTemplates /></ProtectedRoute>} />
          <Route path="/admin/vertraege" element={<ProtectedRoute allowedRoles={['admin','superadmin']}><ContractSignings /></ProtectedRoute>} />
          {/* Neues Personal-Center */}
          <Route path="/admin/personal" element={<ProtectedRoute allowedRoles={['admin','superadmin']}><PersonalDashboard /></ProtectedRoute>} />
          <Route path="/admin/personal/mitarbeiter/:employeeId" element={<ProtectedRoute allowedRoles={['admin','superadmin']}><EmployeeDetail /></ProtectedRoute>} />
          {/* Eigenständige BV-Verwaltung für Admin + SL (mit bv_permission) */}
          <Route path="/admin/betriebsvereinbarungen" element={<ProtectedRoute allowedRoles={['admin','superadmin','stationsleitung']}><BVManagementPage /></ProtectedRoute>} />
          {/* Redirect: /admin/employees → /admin/personal?tab=mitarbeiter */}
          <Route path="/admin/employees" element={<Navigate to="/admin/personal?tab=mitarbeiter" replace />} />
          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          {/* Safety-Net: Zeigt Fehlermeldung statt scheinbarem Logout */}
          <Route path="/unauthorized" element={
            <div className="min-h-screen flex items-center justify-center bg-background p-4">
              <div className="text-center space-y-4">
                <h2 className="text-2xl font-bold text-foreground">Kein Zugriff</h2>
                <p className="text-muted-foreground">Sie haben keine Berechtigung für diese Seite.</p>
                <a href="/employee/dashboard" className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm">
                  Zurück zum Dashboard
                </a>
              </div>
            </div>
          } />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </OnboardingProvider>
      </BrowserRouter>
      </InfoModulesProvider>
      <Toaster />
      </ModulesProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

/** Einfache 404-Seite – zeigt immer die korrekte Admin/Employee-Navigation via DashboardLayout
 *  wenn der User eingeloggt ist, sonst Redirect auf /login */
function NotFoundPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <DashboardLayout>
      <div className="min-h-[60vh] flex items-center justify-center p-8">
        <div className="text-center space-y-4 max-w-md">
          <p className="text-6xl font-bold text-muted-foreground/30">404</p>
          <h2 className="text-2xl font-bold text-foreground">Seite nicht gefunden</h2>
          <p className="text-muted-foreground">
            Die aufgerufene Seite existiert nicht oder wurde verschoben.
          </p>
          <button
            onClick={() => navigate(user.role === 'admin' ? '/admin' : '/employee')}
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            Zum Dashboard
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default App;
